/**
 * Created by user on 2018/7/29/029.
 */

export * from '@lazy-cjk/util/strtable';
import m from '@lazy-cjk/util/strtable';

export default m;
